let menuPageInter = {
    init() {

        var submenu = $('.main-menu .is-active').parent().parent().html();

        if($('body').hasClass('page-node-type-document-pro')) {
            let urlParams = new URLSearchParams(window.location.search);
            if(urlParams.has('type')) {
                let el = $('.main-menu a[href="' + window.location.pathname + '"]');
                el.addClass('is-active');
                submenu = el.parent().parent().html();
            }
        }

        $(submenu).appendTo('.ssnav');


        var nbul = $('.ssnav > li > ul').length;

        if (nbul > 1){
            $('.ssnav').empty();
        }
    }
}

export default menuPageInter;
